import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'

import { SidebarRow } from '../SidebarRow'
import type { ISidebarTopInfo } from './types'

export const SidebarTopInfo: FC<ISidebarTopInfo> = ({ projectInfo }) => {
  if (!projectInfo) {
    return (
      <Text view="primary" size="s">
        Деталей по проекту нет
      </Text>
    )
  }

  return (
    <>
      <SidebarRow type="Скважины" value={projectInfo.projectWellCount} />
      <SidebarRow type="Инклинометрия" value={projectInfo.projectInclinometryCount} />
      <SidebarRow type="Полигоны" value={projectInfo.projectRigisCount} />
      <SidebarRow type="Маркеры" value={projectInfo.projectMarkerCount} />
      <SidebarRow type="Кери" value={projectInfo.projectCoreCount} />
      <SidebarRow type="Данные скважин" value={projectInfo.projectWellDataCount} />
      <SidebarRow type="ГИС" value={projectInfo.projectGisCount} />
      <SidebarRow type="Поверхности" value={projectInfo.projectSurfaceCount} />
      <SidebarRow type="Пласты" value={projectInfo.projectLayerCount} />
      <SidebarRow type="Испытания" value={projectInfo.projectTestCount} />
    </>
  )
}
